export const COLORS = {
  accent: '#4f3a8e',
  ink: '#1a1a1a',
  mutedInk: '#4a4a4a',
  softBg: '#f8f8f8',
  lightBg: '#f5f5f5',
  border: '#e0e0e0',
  mutedBorder: '#ccc',
  bg: '#ffffff',
};

export const SPACE = {
  xs: '0.25rem',
  sm: '0.5rem',
  md: '1rem',
  lg: '1.5rem',
  xl: '2rem',
  xxl: '3rem',
};

export const FONT = {
  // System sans for UI chrome (sidebar, nav, lists).
  sans: "system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif",
  // Native serif stack for prose (page title, section headings, About copy).
  serif: "Charter, 'Iowan Old Style', 'Source Serif Pro', Palatino, Georgia, serif",
};

export const BREAKPOINT = {
  narrow: '899px',
};
